<div class="tp-box vd-host w-100" [@flipState]="flip">
	<div class="row tp-box__side tp-box__back" *ngIf="flip == 'active'">
		<div class="cw-wrap vd-wrap" [ngStyle]="themeVars">
			<div class="cw-icon-badge pointer" (click)="toggleFlip(false, '')" title="Back">
				<i class="material-icons">inventory</i>
			</div>
			<div class="cw-header">
				<div class="cw-title-group">
					<span class="cw-title">{{ title }}</span>
				</div>
				<div class="vd-toolbar">
					<button class="btn btn-success btn-sm" (click)="exportXls()" [disabled]="exporting || !viewing || viewing.length === 0">
						<i class="fa fa-file-excel-o"></i>
					</button>
					<button class="btn btn-danger btn-sm" (click)="exportPdf()" [disabled]="exporting || !viewing || viewing.length === 0">
						<i class="fa fa-file-pdf-o"></i>
					</button>
				</div>
			</div>
			<div class="cw-body" *ngIf="viewing">
				<div class="table" #print_table>
					<table class="table">
						<tr>
							<th>Order#</th>
							<th>Vendor</th>
							<th>Date</th>
							<th>Ordered</th>
							<th>Received</th>
							<th>Remaining</th>
						</tr>
						<tr *ngFor="let v of viewing">
							<td>{{ v.orderno }}</td>
							<td>{{ v.supplierid }}</td>
							<td>{{ v.orddate }}</td>
							<td>{{ v.ordered }}</td>
							<td>{{ v.rec }}</td>
							<td>{{ getRemaining(v.ordered, v.rec) }}</td>
						</tr>
					</table>
				</div>
			</div>
		</div>
	</div>
	<div class="row tp-box__side tp-box__front" id="frontside" [ngClass]="flip == 'inactive' ? '' : 'd-none'">
		<div class="col-12 p-0">
			<app-dashboard-stat-card
				[title]="title"
				icon="inventory"
				accent="warning"
				[value]="data ? data.length : null"
				[loading]="!data"
				[showView]="!!data"
				(view)="toggleFlip(data, title)">
			</app-dashboard-stat-card>
		</div>
	</div>
</div>
